/* Niclas + ChatGPT | 2026-10-02 | AVOLT global chat */
function onTidioChatApiReady() {
  // Flytta knappen ner 34px
  tidioChatApi.adjustStyles('#tidio { bottom: -34px !important; right: -2px !important; }');
  
  // Mobile version
  tidioChatApi.adjustStyles(
    '@media only screen and (max-width: 980px) { #tidio { bottom: -2px !important; right: 6px !important; } }',
  );
}

if (window.tidioChatApi) {
  window.tidioChatApi.on('ready', onTidioChatApiReady);
} else {
  document.addEventListener('tidioChat-ready', onTidioChatApiReady);
}
